/**
 * Media upload — POST /api/v1/media/upload
 * Sube un fichero (multipart/form-data) para evidencias POD.
 */

export interface MediaUploadResponse {
  url: string;
  filename: string;
  mimetype: string;
  size: number;
}

export async function uploadMedia(token: string, file: File): Promise<MediaUploadResponse> {
  const formData = new FormData();
  formData.append("file", file);

  const res = await fetch("/api/v1/media/upload", {
    method: "POST",
    headers: { Authorization: `Bearer ${token}` },
    body: formData,
  });

  if (!res.ok) {
    const msg = await res.text().catch(() => res.statusText);
    throw new Error(`Media upload failed (${res.status}): ${msg}`);
  }

  return res.json() as Promise<MediaUploadResponse>;
}
